import { ROUTE_PATH } from 'common/constants/sm-constants';
import { GridMetaModel } from 'common/models/utility-models/meta-model';

export class studentInternshipGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Internship',
      ROUTE_PATH.studentInternship,
      '',
      false,
      false,
      8,
      false,
      false
    );
  }
  override initProperties() {
    const dataInfo = super.initProperties();
    // const tabData = ['Asked For Internship','Internship Assigned','Incomplete Internships','Completed Internship'];
    const tabData = new TabData()
    const tabNumber:number=1;
    dataInfo.tabData = tabData;
    dataInfo.tabNumber=tabNumber;
    return dataInfo;
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];

    return headers;
  }
}

export class TabData {
  // askedForInternship: { label: string; values: [] } = {
  //   label: 'Asked For Internship',
  //   values: [],
  // };
  // internshipAssigned: { label: string; values: [] } = {
  //   label: 'Internship Assigned',
  //   values: [],
  // };
  // incompleteInternships: { label: string; values: [] } = {
  //   label: 'Incomplete Internships',
  //   values: [],
  // };
  // completeinternships: { label: string; values: [] } = {
  //   label: 'Completed Internship',
  //   values: [],
  // };

  tabValue: any = [
    { name: "Asked for Internship" },
    { name: "Internship assigned" },
    { name: "Incomplete Internships" },
    { name: "Completed Internship" },
  ];
  navValue: any = 'Asked for Internship';

 
}
